import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const OUTCOME = {
  hit: { label: "Confirmed (hit)", text: "text-emerald-400", border: "border-emerald-400/50", bg: "bg-emerald-400" },
  late: { label: "Confirmed (late)", text: "text-lime-300", border: "border-lime-300/50", bg: "bg-lime-300" },
  miss: { label: "Miss", text: "text-atlas-red", border: "border-atlas-red/50", bg: "bg-atlas-red" },
  persisted: { label: "Still elevated", text: "text-amber-300", border: "border-amber-400/50", bg: "bg-amber-400" },
  pending: { label: "Window pending", text: "text-atlas-cyan", border: "border-atlas-cyan/50", bg: "bg-atlas-cyan" },
};

// Four-part bar: every prediction is in exactly one outcome.
export const OutcomeBar = ({ oc }) => {
  if (!oc) return null;
  const total = Object.values(oc).reduce((a, b) => a + b, 0) || 1;
  return (
    <div className="mb-4" data-testid="outcome-bar">
      <div className="flex h-2.5 w-full overflow-hidden border border-white/10">
        {Object.keys(OUTCOME).map((k) => (
          <div key={k} className={OUTCOME[k].bg} style={{ width: `${(100 * (oc[k] || 0)) / total}%` }} />
        ))}
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-1 mt-1.5">
        {Object.entries(OUTCOME).map(([k, o]) => (
          <span key={k} className={`text-[10px] font-mono ${o.text}`} data-testid={`outcome-count-${k}`}>{o.label} {oc[k] || 0}</span>
        ))}
      </div>
      <p className="text-[9px] font-mono text-atlas-secondary/80 mt-1">Confirmed (late) counts as a hit. Still elevated is held out of hit rate, Brier and false-positive rate for 72 more hours, then becomes Confirmed (late) or a miss.</p>
    </div>
  );
};

export const AlertPolicy = () => {
  const [p, setP] = useState(null);
  useEffect(() => { api.alertPolicy().then(setP).catch(() => {}); }, []);
  if (!p) return null;
  return (
    <div className="mb-5 border border-white/10 bg-atlas-void/40 p-3" data-testid="alert-policy">
      <div className="text-[10px] uppercase tracking-widest text-atlas-cyan/60 font-mono mb-2">How alerts work</div>
      <table className="w-full text-[10px] font-mono">
        <tbody>
          {p.bands.map((b) => (
            <tr key={b.band} className="border-b border-white/5 align-top" data-testid={`alert-band-${b.band}`}>
              <td className="py-1.5 pr-2 text-white whitespace-nowrap">{b.range}</td>
              <td className="py-1.5 pr-2 text-atlas-cyan whitespace-nowrap">{b.label}</td>
              <td className="py-1.5 text-atlas-secondary">{b.effect}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="text-[9px] text-atlas-secondary/80 mt-2">{p.rule_alerts}</p>
      <p className="text-[9px] text-atlas-secondary/80 mt-1">{p.calibration}</p>
      <p className="text-[9px] text-atlas-secondary/80 mt-1">{p.flood_rule}</p>
    </div>
  );
};
